import constants from '../constants/createAccount';

const validatePassword = password =>
  password.length >= constants.passwordMinLength;

export default validatePassword;
